import { Checkbox } from '@lokalise/louis';

interface DefaultReviewersCheckboxProps {
    value: boolean;
    onChange: (value: boolean) => void;
}

const DefaultReviewersCheckbox = ({ value, onChange }: DefaultReviewersCheckboxProps) => (
    <Checkbox name="DefaultReviewersCheckbox" checked={value} onChange={(e) => onChange(e.target.checked)}>
        Assign default reviewers
    </Checkbox>
);

export default DefaultReviewersCheckbox;
